<template>
	<div class="content-scroll">
		<div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
				<el-tab-pane label="已注册产品列表" name="first"></el-tab-pane>
			</el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus" title="新增">新增</el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="company">
                    <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item label="是否寄注册样品" prop="isSamples">
                  <el-select clearable size="small"  v-model="filters.isSamples" placeholder="请选择">
                    <el-option label="未邮寄" :value="0"></el-option>
                    <el-option label="已邮寄" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否注册成功" prop="isSuccess">
                  <el-select clearable size="small"  v-model="filters.isSuccess" placeholder="请选择">
                    <el-option label="已成功" :value="1"></el-option>
                    <el-option label="注册中" :value="0"></el-option>
                    <el-option label="未成功" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="primary" @click="handleExport()">导出</el-button>
                </el-form-item>
              <el-form-item>
                <el-button size="small" class="el-icon-download" type="danger" @click="handleExportTemplate()">模板下载</el-button>
              </el-form-item>
                <el-form-item>
                    <el-upload
                        ref='import'
                        :action="root + uploadUrl"
                        :show-file-list="false"
                        :on-success="importSuccess"
                        :before-upload="beforeImportFile"
                        :on-error="handleError"
                        :headers="{'username': username }">
                        <el-button size="small" type="warning">已注册产品导入</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <!--列表-->
            <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
                <el-table-column prop="nbr" label="序号" width="130" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="isSamples" label="是否寄注册样品" :formatter="samplesFormatter" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="isSuccess" label="是否注册成功" :formatter="successFormatter" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="product" label="注册产品"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="company" label="注册公司"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="contact" label="联系人" min-width="120"></el-table-column>
                <el-table-column label="操作" width="160" align="right" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)" icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '已注册产品编辑':'已注册产品新增'" :visible.sync="aVisible" width="80%" :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="180px" ref="formFileds" size="small">
                  <el-form-item label="客户：" prop="customerId" class="w450">
                    <el-button size="small" :type="formData.customerId ? '' : 'primary'" @click="cVisible = true">{{ formData.customerId ? '已选择Id(' + formData.customerId + ')' : '选择客户'}}</el-button>
                  </el-form-item>
                  <el-form-item label="是否寄注册样品" prop="isSamples" class="inlineForm w450">
                    <el-select clearable size="small"  v-model="formData.isSamples" placeholder="请选择">
                      <el-option label="未邮寄" :value="0"></el-option>
                      <el-option label="已邮寄" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="注册产品" prop="product" class="inlineForm w450">
                    <el-input clearable v-model="formData.product"></el-input>
                  </el-form-item>
                    <el-form-item label="是否注册成功" prop="isSuccess" class="inlineForm w450">
                      <el-select clearable size="small"  v-model="formData.isSuccess" placeholder="请选择">
                        <el-option label="已成功" :value="1"></el-option>
                        <el-option label="注册中" :value="0"></el-option>
                        <el-option label="未成功" :value="-1"></el-option>
                      </el-select>
                    </el-form-item>
                  <el-form-item label="注册公司" prop="company" class="inlineForm w450">
                    <el-input clearable v-model="formData.company"></el-input>
                  </el-form-item>
                  <el-form-item label="国家" prop="country" class="inlineForm w450">
                    <el-input clearable v-model="formData.country"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" prop="contact" class="inlineForm w450">
                    <el-input clearable v-model="formData.contact"></el-input>
                  </el-form-item>
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)" :loading="bLoading">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog :visible.sync="cVisible" width="1300px" :modal-append-to-body="true" :close-on-click-modal="false" top="5%">
              <div class="solt-header">
                <h2>客户选择</h2>
              </div>
              <customer-list v-if="cVisible" @material="setMaterial"></customer-list>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomerList from '@/components/CustomerList.vue'
export default {
    components:{
      CustomerList,
    },
    data() {
        return {
            pageUrl:'/product/list/page',
            updateUrl:'/product/saveOrUpdate',
            addUrl:'/product/saveOrUpdate',
            deleteUrl:'/product/remove',
            exportUrl:'/product/export',
            exportTemplateUrl:'/product/exportTemplate',
            importUrl:'/product/import',

            filters:{
                pageSize: 10,
                pageIndex: 1,
                company:'',
                isSamples:'',
            },
            
            formData:{
                company:'',
                contact:'',
                country:'',
                id:'',
                isSamples:0,
                product:'',
                isSuccess:-1,
                customerId:'',
            },
            formRules: {
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' } 
                ],
                product: [
                    { required: true, message: '请输入注册产品', trigger: 'blur' }
                ],
                isSamples: [
                  { required: true, message: '请选择样品邮寄状态', trigger: 'blur' }
                ],
                isSuccess: [
                  { required: true, message: '请选择产品注册状态', trigger: 'blur' }
                ],
            },
            fileList: [],
        }
    },
    computed:{
        ...mapGetters(['username'])
    },
    mounted(){
      this.filters.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
      this.formData.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
      this.getPage()
    },
    methods: {
        setMaterial(row){
          this.cVisible = false;
          this.formData.customerId = row.id;
          row.id = this.formData.id;
          this.mergeObject(this.formData, row)
        },
        beforeUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!file.name.includes("jpg") && !file.name.includes("png") && !file.name.includes("jpeg")) {
                this.$message.warning("只能上传jpg/png文件");
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
                return false;
            }
        },
        samplesFormatter(row,column) {
          if(row.isSamples == 0) {
            return "未邮寄"
          }
          if(row.isSamples == 1) {
            return "已邮寄"
          }
        },
        successFormatter(row,column) {
          if(row.isSuccess == 1) {
            return "已成功"
          }
          if(row.isSuccess == 0) {
            return "注册中"
          }
          if(row.isSuccess == -1) {
            return "未成功"
          }
        }
    },
    created(){
        this.getPage()
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>